import React, { useRef, useEffect, useState, useContext } from 'react';
import { FormControl, InputLabel, Autocomplete, Select, MenuItem, TextField, Box, Typography } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import FilterListIcon from '@mui/icons-material/FilterList'; //
import Chart from 'chart.js/auto';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './dashboard.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import UserContext from '../../Context/User/userContext';

const Managers = [
  { title: 'All' },
  { title: 'Maheen' },
  { title: 'Wardah' },
  { title: 'Evelyn' },
  { title: 'Shariq' },
  { title: 'Ibrahim' },
  { title: 'Owais' },

  // Add more therapeutic areas as needed
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#169a8f',
    color: theme.palette.common.white,
    textAlign: 'center',
    fontWeight:800,
    fontSize: 16,
    fontFamily:'nunito'

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: 'center',
    fontFamily:'nunito'

  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const ChartComponent = ({ setShowSpinner }) => {
  const chartRef = useRef(null);
  const [manager, setManager] = useState('All');
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [tillDate, setTillDate] = useState(moment().format("YYYY-MM-DD"));
  const [data, setData] = useState({});
  const [chartData, setChartData] = useState(null);
  const [visible, setVisible] = useState(false);

  //User
  const { user, setUser } = useContext(UserContext);

  const handleChangeManager = (event) => {
    setManager(event.target.value);
  };

  const handleChangeFromDate = (event) => {
    setFromDate(event.target.value);
  };

  const handleChangeTillDate = (event) => {
    setTillDate(event.target.value);
  };

  const handleApplyFilters = (manager, fromDate, tillDate) => {
    // Implement apply filters logic here
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";
    const filter = {
      manager,
      fromDate,
      toDate: tillDate
    }
    setShowSpinner(true);
    axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/status`, filter, {
      headers: {
        'Authorization': `Bearer ${tokenValue}`
        // You can add other headers if needed like authorization token, etc.
      }
    })
      .then(res => {
        const response = res.data.status;
        setData(response);
      })
      .catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .finally(() => {
        setShowSpinner(false);
      })

  };

  useEffect(() => {
    if (user) {
      handleApplyFilters(manager, '', '')
    }
  }, [])

  useEffect(() => {
    // if (!chartData) {
    const convertedData = {
      smo: Number(data.smo),
      cda: Number(data.cda),
      protocol: Number(data.protocol),
      pssv: Number(data.pssv),
      budget: Number(data.budget),
      siv: Number(data.siv),
      invoicing: Number(data.invoicing),
      allClear: Number(data.allClear),
    };
    const totalUsers = convertedData.smo + convertedData.cda + convertedData.protocol + convertedData.pssv + convertedData.budget + convertedData.siv + convertedData.invoicing;
    const smo = (convertedData.smo / totalUsers) * 100;
    const cda = (convertedData.cda / totalUsers) * 100;
    const protocol = (convertedData.protocol / totalUsers) * 100;
    const pssv = (convertedData.pssv / totalUsers) * 100;
    const budget = (convertedData.budget / totalUsers) * 100;
    const siv = (convertedData.siv / totalUsers) * 100;
    const invoicing = (convertedData.invoicing / totalUsers) * 100;
    const allClear = (convertedData.allClear / totalUsers) * 100;
    setChartData({
      labels: ['SMO', 'CDA', 'Protocol/FQ', 'PSSV', 'Budget/CTA', 'SIV', 'Invoicing', 'All Clear'],
      datasets: [
        {
          data: [smo, cda, protocol, pssv, budget, siv, invoicing, allClear],
          backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#e90a1f', '#cb0ce5', '#0f8d12', '#0a3ce9', '#169a8f'],
          hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#e90a1f', '#cb0ce5', '#0f8d12', '#0a3ce9', '#169a8f'],
        },
      ],
    });
    // }

    if (chartRef.current && chartRef.current.chartInstance) {
      chartRef.current.chartInstance.destroy();
    }

    const ctx = chartRef.current?.getContext('2d');

    if (ctx) {
      const newChartInstance = new Chart(ctx, {
        type: 'doughnut',
        data: chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            animateRotate: true,
            animateScale: true,
          },
          plugins: {
            legend: {
              labels: {
                font: {
                  size: 14,
                },
              },
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  let label = context.dataset.labels[context.dataIndex] || '';
                  if (label) {
                    label += ': ';
                  }
                  label += context.formattedValue;
                  return label;
                },
              },
            },
          },
          onHover: (event, chartElement) => {
            if (chartElement.length > 0) {
              event.native.target.style.cursor = 'pointer';
            } else {
              event.native.target.style.cursor = 'default';
            }
          },
        },
      });

      chartRef.current.chartInstance = newChartInstance;
    }

    return () => {
      if (chartRef.current && chartRef.current.chartInstance) {
        chartRef.current.chartInstance.destroy();
      }
    };
  }, [data]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', padding: '20px' }}>
      <h1>Managers Study Dashboard</h1>
      {/* <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Card style={{ backgroundColor: '#eab3af', color: '#fff' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Card 1
            </Typography>
            <Typography variant="body1">
              This is some text inside the first card.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card style={{ backgroundColor: '#9bc3e3', color: '#fff' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Card 2
            </Typography>
            <Typography variant="body1">
              This is some text inside the second card.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card style={{ backgroundColor: '#89dd8d', color: '#fff' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Card 3
            </Typography>
            <Typography variant="body1">
              This is some text inside the third card.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card style={{ backgroundColor: '#ecc386', color: '#fff' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Card 4
            </Typography>
            <Typography variant="body1">
              This is some text inside the fourth card.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid> */}
      {/* <fieldset className='field' style={{ width: '80%', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Processing Filter</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', marginTop:'20px', justifyContent: 'space-between', width: '100%' }}>
          <FormControl sx={{ width: '30%' }}>
            <InputLabel id="manager-label">Manager</InputLabel>
            <Select
              labelId="manager-label"
              id="manager-select"
              value={manager}
              onChange={handleChangeManager}
            >
              <MenuItem value="manager1">Manager 1</MenuItem>
              <MenuItem value="manager2">Manager 2</MenuItem>
              <MenuItem value="manager3">Manager 3</MenuItem>
            </Select>
          </FormControl>
          <TextField
            id="from-date"
            label="From Date"
            type="date"
            value={fromDate}
            onChange={handleChangeFromDate}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: '30%' }}
          />
          <TextField
            id="till-date"
            label="Till Date"
            type="date"
            value={tillDate}
            onChange={handleChangeTillDate}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: '30%' }}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <Button variant="contained" onClick={handleApplyFilters}>Apply</Button>
        </Box>
      </fieldset> */}
      <div className='mt-4'>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 1100 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell >Manager Name</StyledTableCell>
                <StyledTableCell align="right">SMO</StyledTableCell>
                <StyledTableCell align="right">CDA</StyledTableCell>
                <StyledTableCell align="right">Protocol/FQ</StyledTableCell>
                <StyledTableCell align="right">PSSV</StyledTableCell>
                <StyledTableCell align="right">Budget/CTA</StyledTableCell>
                <StyledTableCell align="right">SIV</StyledTableCell>
                <StyledTableCell align="right">Invoicing</StyledTableCell>
                <StyledTableCell align="right">All Steps Clear</StyledTableCell>
                <StyledTableCell align="right">Total</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow >
                <StyledTableCell align="right">{manager}</StyledTableCell>
                <StyledTableCell align="right">{data && data.smo}</StyledTableCell>
                <StyledTableCell align="right">{data && data.cda}</StyledTableCell>
                <StyledTableCell align="right">{data && data.protocol}</StyledTableCell>
                <StyledTableCell align="right">{data && data.pssv}</StyledTableCell>
                <StyledTableCell align="right">{data && data.budget}</StyledTableCell>
                <StyledTableCell align="right">{data && data.siv}</StyledTableCell>
                <StyledTableCell align="right">{data && data.invoicing}</StyledTableCell>
                <StyledTableCell align="right">{data && data.allClear}</StyledTableCell>
                <StyledTableCell align="right">
                  {
                    data
                    &&
                    (
                      data.smo +
                      data.cda +
                      data.protocol +
                      data.pssv +
                      data.budget +
                      data.siv +
                      data.invoicing +
                      data.allClear
                    )
                  }
                </StyledTableCell>

              </StyledTableRow>
              <StyledTableRow>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Box sx={{ mt: 3, width: '30%', display: 'flex', justifyContent: 'center' }}>
        {chartData && <Doughnut ref={chartRef} data={chartData} />} {/* Pass chartData to Doughnut component */}
      </Box>
      <div className="card flex justify-content-center">
        <Sidebar visible={visible} onHide={() => setVisible(false)} position="right" className="w-full clr md:w-40rem lg:w-60rem">
          <div className='sidebar'>
            <h1>Filters</h1>
            <Autocomplete className='mt-5'
              id="therapeutic-areas"
              options={Managers}
              getOptionLabel={(option) => option.title}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Manager"
                  fullWidth
                  InputLabelProps={{
                    style: { fontSize: 15, color: '#169a8f' } // Style for InputLabel
                  }}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: 15 } // Style for input text
                  }}
                  value={manager}
                  onBlur={handleChangeManager}
                />
              )}
              style={{ fontSize: 15 }}

            // MenuProps={{
            //   anchorOrigin: {
            //     vertical: 'bottom', // Ensure menu opens downward
            //     horizontal: 'left',
            //   },
            //   transformOrigin: {
            //     vertical: 'top',
            //     horizontal: 'left',
            //   },
            //   getContentAnchorEl: null, // Prevent menu from being anchored to the input
            //   PaperProps: {
            //     style: {
            //       maxHeight: 300,
            //       width: '20ch',
            //     },
            //   },
            // }}
            />
            <TextField
              id="from-date"
              label="From Date"
              type="date"
              value={fromDate}
              onChange={handleChangeFromDate}
              InputLabelProps={{ shrink: true, style: { fontSize: 16, color: '#169a8f' } }} InputProps={{ style: { fontSize: 16 } }}
              sx={{ width: '100%', marginBottom: '1rem', marginTop: '1.4rem' }}
            />
            <TextField
              id="till-date"
              label="Till Date"
              type="date"
              value={tillDate}
              onChange={handleChangeTillDate}
              InputLabelProps={{ shrink: true, style: { fontSize: 16, color: '#169a8f' } }} InputProps={{ style: { fontSize: 16 } }}
              sx={{ width: '100%', marginBottom: '1rem', marginTop: '1.4rem' }}
            />
            <div className='mt-5 saveBtnStyle'>
              <button className="cta" onClick={e => handleApplyFilters(manager, fromDate, tillDate)}>
                <span>Apply</span>
                <svg width="15px" height="10px" viewBox="0 0 13 10">
                  <path d="M1,5 L11,5"></path>
                  <polyline points="8 1 12 5 8 9"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </Sidebar>
        <Button variant="outlined" style={{ position: 'fixed', top: '20px', right: '20px', background: 'transparent', color: '#169a8f', border: 'none' }} onClick={() => setVisible(!visible)}>
          <FilterListIcon sx={{ fontSize: 40 }} />
        </Button>
      </div>

    </Box>
  );
};

export default ChartComponent;